import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

const Header: React.FC = () => {
  return (
    <header className="edumorph-header">
      <div className="container">
        <Link to="/" className="logo">
          <img src="/brain.png" alt="Edumorph Logo" className="logo-icon" width="24" height="24" />
          <span>Edumorph</span>
        </Link>
      </div>
    </header>
  );
};

export default Header;
